<div class="p-6" *ngIf="!activeProductForm">
  <!-- Header con nombre del producto -->
  <div *ngIf="productData" class="animate-slide-in-left pb-4">
    <p class="text-2xl text-dark">{{ productData.name || 'Producto sin nombre' }}</p>
  </div>

  <div class="flex justify-between items-center border-b border-gray-200 mb-6">
    <div class="flex">
      <div *ngFor="let tab of detailsTabs; let i = index; trackBy: trackByTabLabel" (click)="activeTabIndex = i"
        [class.border-primary]="activeTabIndex === i" class="cursor-pointer px-4 py-2 text-[1rem] font-bold border-b-2"
        [ngClass]="
          activeTabIndex === i
            ? 'text-primary border-primary'
            : 'text-dark border-transparent duration-200 hover:text-primary'
        ">
        {{ tab.label }}
      </div>
    </div>
  </div>

  <div class="tab-content">
    <!-- Información General -->
    <div *ngIf="activeTabIndex === 0" class="space-y-6">

      <!-- Estado de carga -->
      <div *ngIf="isLoading" class="bg-white rounded-lg shadow-sm border p-6">
        <div class="animate-pulse">
          <div class="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div *ngFor="let i of [1,2,3,4]">
              <div class="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
              <div class="h-5 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
          <div class="mt-6">
            <div class="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
            <div class="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div class="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>
        </div>
      </div>

      <!-- Datos del producto -->
      <div *ngIf="!isLoading && productData" class="bg-white rounded-lg shadow-sm border p-6">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold text-gray-900">Información del Producto</h3>
          <button (click)="toggleActiveProductForm()"
            class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary hover:text-white transition-colors duration-200">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Nombre del Producto</label>
            <p class="text-sm" [ngClass]="productData.name ? 'text-gray-900 font-medium' : 'text-gray-400 italic'">
              {{ productData.name || '—' }}
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Permiso Oficial</label>
            <div class="flex flex-wrap gap-2">
              <span *ngFor="let license of getUniqueLicenses()"
                class="inline-flex px-3 py-1 text-sm font-medium rounded-full bg-green-100 text-green-800">
                {{ license }}
              </span>
              <span *ngIf="getUniqueLicenses().length === 0" class="text-sm text-gray-400 italic">—</span>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Precio Total</label>
            <p class="text-sm" [ngClass]="productData.total_price ? 'text-gray-900' : 'text-gray-400 italic'">
              {{ productData.total_price ? (productData.total_price + ' €') : '—' }}
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Contrato</label>
            <span *ngIf="productData.template" class="inline-flex px-3 py-1 text-sm font-medium rounded-full bg-gray-100 text-gray-800">
              {{ productData.template.name }}
            </span>
            <span *ngIf="!productData.template" class="text-sm text-gray-400 italic">—</span>
          </div>
        </div>
        <div class="mt-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
          <p class="text-sm" [ngClass]="productData.description ? 'text-gray-600' : 'text-gray-400 italic'">
            {{ productData.description || '—' }}
          </p>
        </div>
        <div class="mt-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Sucursales</label>
          <div class="flex flex-wrap gap-2">
            <span *ngFor="let office of getUniqueOffices()"
              class="inline-flex px-3 py-1 text-sm font-medium rounded-full bg-red-100 text-red-800">
              {{ getOfficeDisplayName(office) }}
            </span>
            <span *ngIf="getUniqueOffices().length === 0" class="text-sm text-gray-400 italic">—</span>
          </div>
        </div>
        <div class="mt-4" *ngIf="productData.requirements && productData.requirements.length > 0">
          <label class="block text-sm font-medium text-gray-700 mb-1">Requisitos</label>
          <ul class="list-disc list-inside space-y-1">
            <li *ngFor="let requirement of productData.requirements" class="text-sm text-gray-600">
              {{ requirement }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Estado sin datos -->
      <div *ngIf="!isLoading && !productData" class="bg-white rounded-lg shadow-sm border p-6 text-center">
        <div class="text-gray-500">
          <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontró información del producto</h3>
          <p class="text-gray-500">El producto solicitado no existe o no se pudo cargar la información.</p>
        </div>
      </div>
    </div>

    <!-- Exámenes -->
    <div *ngIf="activeTabIndex === 1" class="space-y-4">
      <app-generic-crud (onFinished)="onFinishForm()" #genericCrudRef [genericCrud]="genericCRUD"></app-generic-crud>
    </div>

    <!-- Cursos -->
    <div *ngIf="activeTabIndex === 2" class="space-y-4">
      <app-generic-crud (onFinished)="onFinishForm()" [genericCrud]="coursesCRUD"></app-generic-crud>
      <div *ngIf="(!productData?.courses || productData.courses.length === 0)"
        class="bg-white rounded-lg shadow-sm border p-6 text-center">
        <div class="text-gray-500">
          <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
          <h3 class="text-lg font-medium text-gray-900 mb-2">No hay cursos asociados</h3>
          <p class="text-gray-500">Este producto no tiene cursos configurados.</p>
        </div>
      </div>
    </div>

    <!-- Tarifas -->
    <div *ngIf="activeTabIndex === 3" class="space-y-4">
      <app-product-price-lists *ngIf="productId" [productId]="productId" (onPriceListsChanged)="loadProductData()"></app-product-price-lists>
    </div>

    <!-- Transiciones de Estado -->
    <div *ngIf="activeTabIndex === 4" class="space-y-4">
      <app-product-transitions *ngIf="productId" [productId]="productId"></app-product-transitions>
    </div>

  </div>
</div>

<!-- Formulario fullscreen de edición de producto -->
<div *ngIf="activeProductForm && productForm" class="w-full min-h-screen bg-white animate-fade-in p-6 relative z-30">
  <!-- Botón de cerrar -->
  <button (click)="toggleActiveProductForm()"
    class="absolute top-6 right-8 w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
  </button>

  <!-- Título -->
  <h2 class="text-2xl font-semibold text-dark mb-6">
    Editar {{ productData?.name || 'Producto' }}
  </h2>

  <!-- Componente de formulario -->
  <app-generic-form (onFinished)="onFinishProductForm()" (onCancel)="toggleActiveProductForm()" [showCancel]="true" [genericForm]="productForm"
    [selectedItem]="productData"></app-generic-form>
</div>
